import { gql } from '@apollo/client';

export const surfaceNodeRevokedSubscription = gql`
  subscription surfaceNodeRevoked($user: ID!) {
    surfaceNodeRevoked(user: $user) {
      revokedSurface
      sharedReference
      user
    }
  }
`;
